import React, { useState, useEffect } from 'react';
import { PlusIcon, MinusCircleIcon } from '@heroicons/react/20/solid';
import { DatePicker } from 'antd';
import { TWButton, TWModal } from '../../../ui';
import productApi from '../../../../services/productApi';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const ProductScheduleModal = ({ show, onClose, product, setProductForm }) => {
  const [form, setForm] = useState(product.productschedules || []);
  const [loading, setLoading] = useState({
    upsertLoading: false,
  });
  useEffect(() => {
    setForm(product.productschedules || []);
  }, [product]);

  const onDateChange = (value, i) => {
    const newForm = [...form];
    newForm[i].startdate = dayjs(value[0]).format('YYYY-MM-DD hh:mm:ss');
    newForm[i].enddate = dayjs(value[1]).format('YYYY-MM-DD hh:mm:ss');

    setForm(newForm);
  };

  const onClickAddSchedule = () => {
    const newForm = [...form];
    newForm.push({
      startdate: null,
      enddate: null,
      isactive: true,
    });
    setForm(newForm);
  };

  const onClickDeleteSchedule = (schedule, i) => {
    const newForm = [...form];
    newForm.splice(i, 1);
    setForm(newForm);
  };

  const onSubmitSchedules = async () => {
    setLoading({ upsertLoading: true });
    const body = {
      productId: product.id,
      schedules: form,
    };

    try {
      const res = await productApi.updateSchedules(body);
      setProductForm(res.data.data);

      onClose();
      setForm(form);
    } catch (error) {
      console.log('error', error);
    } finally {
      setLoading({ upsertLoading: false });
    }
  };

  return (
    <TWModal
      open={show}
      onClose={() => {
        onClose();
        setForm(form);
      }}
      title="Schedule Product visibility"
      description="Set start and end dates to schedule this product. It will be visible to customers only during the specified times."
      size="2xl"
      panelClassName="dark:text-slate-200"
    >
      <div className="space-y-2">
                    {form?.map((schedule, i) => (
                      <div key={i} className="flex gap-4">
                        <div className="w-full">
                          <label
                            htmlFor="description"
                            className="block text-sm font-medium text-gray-700 dark:text-slate-200"
                          >
                            Date Range
                          </label>
                          <div className="pt-1 w-full">
                            <RangePicker
                              showTime={{
                                use12Hours: true,
                                format: 'hh:mm A',
                                minuteStep: 15,
                              }}
                              style={{ width: '100%' }}
                              format="MM/DD/YYYY hh:mm A"
                              size="large"
                              value={[
                                schedule.startdate
                                  ? dayjs(
                                      schedule.startdate,
                                      'YYYY-MM-DD hh:mm'
                                    )
                                  : null,
                                schedule.enddate
                                  ? dayjs(schedule.enddate, 'YYYY-MM-DD hh:mm')
                                  : null,
                              ]}
                              onChange={(e) => {
                                onDateChange(e, i);
                              }}
                            />
                          </div>
                        </div>
                        {/*    <div className="">
                          <label
                            htmlFor="default"
                            className="block text-sm font-medium text-gray-700 dark:text-slate-400"
                          >
                            Active
                          </label>
                          <div className="mt-2">
                            <Switch
                              checked={schedule.isactive}
                              onChange={(e) => {
                                onFormChange(e, 'isactive', i);
                              }}
                              className={classNames(
                                schedule.isactive
                                  ? 'bg-blue-600'
                                  : 'bg-gray-200',
                                'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2'
                              )}
                            >
                              <span
                                aria-hidden="true"
                                className={classNames(
                                  schedule.isactive
                                    ? 'translate-x-5'
                                    : 'translate-x-0',
                                  'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                                )}
                              />
                            </Switch>
                          </div>
                        </div> */}
                        <div>
                          <MinusCircleIcon
                            onClick={() => onClickDeleteSchedule(schedule, i)}
                            className="text-red-500 ml-3 mt-7 w-5 h-5 hover:text-red-900 cursor-pointer"
                          />
                        </div>
                      </div>
                    ))}
                    <div>
                      <div className="pt-4 justify-center dark:hover:bg-slate-700 flex p-1 text-sm font-medium rounded-md text-blue-500 dark:text-slate-200">
                        <div
                          className="flex items-center cursor-pointer justify-center gap-1 hover:bg-slate-50"
                          onClick={() => onClickAddSchedule()}
                        >
                          <button
                            type="button"
                            className="rounded-full bg-blue-600 p-1 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                          >
                            <PlusIcon className="h-5 w-5" aria-hidden="true" />
                          </button>
                          <span className="truncate font-semibold text-[0.925rem]">
                            Add Schedule
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-6 grid z-10 sm:grid-flow-row-dense grid-cols-12 gap-3 py-4 sm:py-0">
                      <TWButton
                        variant="default"
                        label="Cancel"
                        disabled={loading.upsertLoading}
                        onClick={() => {
                          onClose();
                          setForm(form);
                        }}
                        className="col-span-6 w-full"
                      />
                      <TWButton
                        variant="primary"
                        label="Save"
                        disabled={loading.upsertLoading}
                        loading={loading.upsertLoading}
                        onClick={() => onSubmitSchedules()}
                        className="col-span-6 w-full"
                      />
        </div>
      </div>
    </TWModal>
  );
};

export default ProductScheduleModal;
